import Repository from "../axios"; 
import { defaultPagination } from "@/constants/config";
const pagination = 150;
const resource = "/admin/staff/maintenances/scheduled-task-schedules";
const resourceTemplate = "/admin/staff/maintenances/scheduled-task-templates";
const resourceTask ="/admin/staff/maintenances/scheduled-task-schedules";
const taskInstance ="/admin/staff/maintenances/scheduled-task-instances";
const taskResponse ="/admin/staff/maintenances/task-instances"

export default {

  allocations(){
    return Repository.get(`${resource}/allocations`);
  },
  frequencies(){
    return Repository.get(`${resource}/frequencies`);
  },
  fieldTypes(){
    return Repository.get(`/admin/staff/maintenances/task-template-fields/types`);
  },
  fetchTaskFields(id){
    return Repository.get(`${resourceTemplate}/${id}/task-template-fields`);
  },
  deleteTaskField(id){
    return Repository.delete(`admin/staff/maintenances/task-template-fields/${id}`);
  },
  createTaskField(id,payload) {
    return Repository.post(`${resourceTemplate}/${id}/task-template-fields`, payload);
  },
  updateTaskField(id, payload) {
    return Repository.put(`admin/staff/maintenances/task-template-fields/${id}`, payload);
  },

  getTemplates(filterQuery = null, pagination=20, page=1) {
    return Repository.get(`${resourceTemplate}?paginate=${pagination}&page=${page}&${filterQuery}`);
  },

  copyTemplate(id){
    return Repository.post(`${resourceTemplate}/${id}/create-new-version`);
  },

  getTemplateDetails(id) {
    return Repository.get(`${resourceTemplate}/${id}`);
  },

  createTemplate(payload) {
    return Repository.post(resourceTemplate, payload);
  },

  updateTemplate(id, payload) {
    return Repository.put(`${resourceTemplate}/${id}`, payload);
  },
  deleteTemplate(id){
    return Repository.put(`${resourceTemplate}/${id}/in-active`);
  },
  setDraftTemplate(id){
    return Repository.put(`${resourceTemplate}/${id}/draft`);
  },
  publishTemplate(id){
    return Repository.put(`${resourceTemplate}/${id}/publish`);
  },
  listTask(filterQuery = '', paginate=20, page=1) {
    return Repository.get(`${resourceTask}?paginate=${paginate}&${filterQuery}&page=${page}`);
  },

  getTask(id) {
    return Repository.get(`${resourceTask}/${id}`);
  },

  createTask(payload) {
    return Repository.post(resourceTask, payload);
  },

  updateTask(id, payload) {
    return Repository.put(`${resourceTask}/${id}`, payload);
  },
  getTaskInstances(filterQuery = '', paginate=20, page=1){
    if(filterQuery == ''){
      return Repository.get(`${taskInstance}/active?paginate=${paginate}&page=${page}&filter[search]=&filter[status]=&filter[completed-by]=&filter[scheduled-from]=&filter[due-date-from]=&filter[due-date-to]=&sort`);
    }
    else {
      return Repository.get(`${taskInstance}/active?paginate=${paginate}&${filterQuery}&page=${page}`);
    }
    
  },
  getCompletedTaskInstances(filterQuery = '', paginate=20, page=1){
    return Repository.get(`${taskInstance}/completed?paginate=${paginate}&page=${page}&${filterQuery}`);

  },
  downloadTaskDetails(id){
    return Repository.get(`/admin/staff/maintenances/task-instances/${id}/generate-task-pdf`, {
      responseType:'blob'
    })
  },
  createTaskInstance(payload){
    return Repository.post(taskInstance, payload);
  },
  getListOfAllTaskInstances(filterQuery = '', paginate=20, page=1){
    return Repository.get(`${taskInstance}/all?paginate=${paginate}&page=${page}&${filterQuery}`);
  },
  getTaskInstance(id){
    return Repository.get(`${taskInstance}/${id}`);
  },
  startTaskInstance(id){
    return Repository.put(`${taskResponse}/${id}/start`);
  },
  completeTaskInstance(id){
    return Repository.put(`${taskResponse}/${id}/complete`);
  },
  submitTaskInstance(id, payload) {
    return Repository.post(`${taskResponse}/${id}/task-responses`, payload);
  },
  getTaskStatuses(){
     return Repository.get(`/admin/staff/maintenances/task-instances/statuses`);
  },
  getTaskInstanceStatus(){
     return Repository.get(`/admin/staff/maintenances/sign-offs/statuses`);
  },
  signOffTaskInstance(id, payload){
    return Repository.post(`${taskResponse}/${id}/sign-offs`, payload);
  }
};